import gql from 'graphql-tag';

import dokkioTagFragment from '../fragments/dokkioTagFragment';

export default gql`
  query dokkioTagByName($name: String!) {
    dokkioTagByName(name: $name) {
      ...dokkioTagFragment
    }
  }
  ${dokkioTagFragment}
`;
